<mat-card
    class="m-4 border border-[#8CAACD] text-[#FF0000] bg-[#E6F0FF] p-[40px]">
    <mat-card-content>{{ 'ppad.no_access_hint' | transloco }}</mat-card-content>
</mat-card>
